<template>
  <div>
    <HeaderIcons :selectedItems="selectedItems" type="moveLoadTableData" @getData="reloadPage" />

    <div v-if="!this.$store.state.allLoading" style="margin-top: 40px">
      <!-- Success/Error Message -->
      <v-snackbar v-model="snackbar.show" :color="snackbar.color" timeout="3000" bottom right>
        {{ snackbar.message }}
      </v-snackbar>

      <div class="table__view">
        <table-component :showSelect="true" itemKey="id" :selectedRows.sync="selected_requests" :headers="headers"
          :pagination="this.$store.state.pagination" :limit="$store.state.counterOfShow"
          :items="this.$store.state.tableData" :loading="loading" @refresh="getTableData" v-model="page">

          <!-- Action Column -->
          <template v-slot:[`item.action`]="{ item }">
            <v-menu offset-y>
              <template v-slot:activator="{ on, attrs }">
                <v-btn color="white" small depressed dark v-bind="attrs" v-on="on">
                  <v-icon style="background: rgb(63, 14, 64); border-radius: 4px">mdi-dots-vertical</v-icon>
                </v-btn>
              </template>
              <v-list>
                <AllSingleProcess :item="item" @getUsersName="getUsersName" @reloadData="getTableData(1)" />
              </v-list>
            </v-menu>
          </template>

          <!-- Quality Notes Tooltip -->
          <template slot="item.quality_notes" slot-scope="props">
            <span v-if="!props.item.quality_notes"></span>
            <v-tooltip bottom v-else>
              <template v-slot:activator="{ on }">
                <span v-on="on">{{
                  props.item.quality_notes.length > 7
                    ? props.item.quality_notes.substring(0, 7) + "..."
                    : props.item.quality_notes
                }}</span>
              </template>
              <div class="font-weight-bold">{{ props.item.quality_notes }}</div>
            </v-tooltip>
          </template>

          <!-- Source Tooltip -->
          <template slot="item.source" slot-scope="props">
            <span v-if="!props.item.source"></span>
            <v-tooltip bottom v-else>
              <template v-slot:activator="{ on }">
                <span v-on="on">{{
                  props.item.source.length > 5
                    ? props.item.source.substring(0, 5) + "..."
                    : props.item.source
                }}</span>
              </template>
              <div class="font-weight-bold">{{ props.item.source }}</div>
            </v-tooltip>
          </template>

          <!-- Type Column -->
          <template slot="item.type" slot-scope="props">
            <span v-if="props.item.type !== 'لا_يوجد'">{{ props.item.type }}</span>
            <span v-else style="color: red">{{ props.item.type }}</span>
          </template>

          <!-- Status Column with Styling -->
          <template slot="item.status" slot-scope="props">
            <span v-if="props.item.status?.includes('مرفوض ')" class="faild__request">
              <v-tooltip bottom>
                <template v-slot:activator="{ on }">
                  <span v-on="on">{{
                    props.item.status.length > 7
                      ? props.item.status.substring(0, 7) + ".."
                      : props.item.status
                  }}</span>
                </template>
                <div class="font-weight-bold">{{ props.item.status }}</div>
              </v-tooltip>
            </span>
            <span v-else-if="
              props.item.status?.includes('طلب جديد') ||
              props.item.status?.includes('طلب تم فتحه')
            " class="new__request">
              <v-tooltip bottom>
                <template v-slot:activator="{ on }">
                  <span v-on="on">{{
                    props.item.status.length > 8
                      ? props.item.status.substring(0, 8) + ".."
                      : props.item.status
                  }}</span>
                </template>
                <div class="font-weight-bold">{{ props.item.status }}</div>
              </v-tooltip>
            </span>
            <span v-else-if="
              props.item.status?.includes('مؤرشف') ||
              props.item.status?.includes('مكتمل')
            " class="archive__request">
              <v-tooltip bottom>
                <template v-slot:activator="{ on }">
                  <span v-on="on">{{
                    props.item.status.length > 7
                      ? props.item.status.substring(0, 7) + ".."
                      : props.item.status
                  }}</span>
                </template>
                <div class="font-weight-bold">{{ props.item.status }}</div>
              </v-tooltip>
            </span>
            <span v-else class="anotherTypes__request">
              <v-tooltip bottom>
                <template v-slot:activator="{ on }">
                  <span v-on="on">{{
                    props.item.status.length > 8
                      ? props.item.status.substring(0, 8) + ".."
                      : props.item.status
                  }}</span>
                </template>
                <div class="font-weight-bold">{{ props.item.status }}</div>
              </v-tooltip>
            </span>
          </template>

          <!-- Editable Customer Name -->
          <template v-slot:[`item.customerName`]="{ item }">
            <div v-if="canEdit(item)" class="editable-field">
              <input type="text" :value="item.customerName"
                @blur="updateField(item, 'cust_name', $event.target.value)" class="editable-input" />
            </div>
            <span v-else>{{ item.customerName }}</span>
          </template>

          <!-- Editable Payment Cost -->
          <template v-slot:[`item.mortCost`]="{ item }">
            <div v-if="canEdit(item)" class="editable-field">
              <input type="number" :value="item.mortCost" @blur="updateField(item, 'mortCost', $event.target.value)"
                class="editable-input" />
            </div>
            <span v-else>{{ item.mortCost }}</span>
          </template>

          <!-- Editable Value Added -->
          <template v-slot:[`item.realEstateValueAdded`]="{ item }">
            <div v-if="canEdit(item)" class="editable-field">
              <input type="number" :value="item.realEstateValueAdded"
                @blur="updateField(item, 'value_added', $event.target.value)" class="editable-input" />
            </div>
            <span v-else>{{ item.realEstateValueAdded }}</span>
          </template>

          <!-- Editable Assessment Fees -->
          <template v-slot:[`item.realEstateAssmentFees`]="{ item }">
            <div v-if="canEdit(item)" class="editable-field">
              <input type="number" :value="item.realEstateAssmentFees"
                @blur="updateField(item, 'assment_fees', $event.target.value)" class="editable-input" />
            </div>
            <span v-else>{{ item.realEstateAssmentFees }}</span>
          </template>

          <!-- Editable Collaborator Commission -->
          <template v-slot:[`item.collaboratorCommission`]="{ item }">
            <div v-if="canEdit(item)" class="editable-field">
              <input type="number" :value="item.collaboratorCommission"
                @blur="updateField(item, 'collobreator_cost', $event.target.value)" class="editable-input" />
            </div>
            <span v-else>{{ item.collaboratorCommission }}</span>
          </template>

          <!-- Editable Pursuit -->
          <template v-slot:[`item.realEstatePursuit`]="{ item }">
            <div v-if="canEdit(item)" class="editable-field">
              <input type="number" :value="item.realEstatePursuit"
                @blur="updateField(item, 'pursuit', $event.target.value)" class="editable-input" />
            </div>
            <span v-else>{{ item.realEstatePursuit }}</span>
          </template>

          <!-- Editable Notes -->
          <template v-slot:[`item.accountcomment`]="{ item }">
            <div v-if="canEdit(item)" class="editable-field">
              <textarea :value="item.accountcomment" @blur="updateComment(item, $event.target.value)"
                class="editable-textarea" rows="2"></textarea>
            </div>
            <span v-else>{{ item.accountcomment }}</span>
          </template>

          <!-- Editable Wsata Mortgage -->
          <template v-slot:[`item.mortgage_value`]="{ item }">
            <div v-if="canEdit(item)" class="editable-field">
              <input type="number" :value="item.mortgage_value"
                @blur="updateField(item, 'mortgage_value', $event.target.value)" class="editable-input" />
            </div>
            <span v-else>{{ item.mortgage_value }}</span>
          </template>

          <!-- Editable Tsaheel Mortgage -->
          <template v-slot:[`item.tsaheel_mortgage_value`]="{ item }">
            <div v-if="canEdit(item)" class="editable-field">
              <input type="number" :value="item.tsaheel_mortgage_value"
                @blur="updateField(item, 'tsaheel_mortgage_value', $event.target.value)" class="editable-input" />
            </div>
            <span v-else>{{ item.tsaheel_mortgage_value }}</span>
          </template>

          <!-- Approval Status Columns -->
          <template v-slot:[`item.is_approved_by_wsata_acc`]="{ item }">
            <v-icon v-if="item.is_approved_by_wsata_acc === 'نعم'" color="green">mdi-check-circle</v-icon>
            <span v-else>-</span>
          </template>

          <template v-slot:[`item.is_approved_by_tsaheel_acc`]="{ item }">
            <v-icon v-if="item.is_approved_by_tsaheel_acc === 'نعم'" color="green">mdi-check-circle</v-icon>
            <span v-else>-</span>
          </template>

          <!-- Agent Notes Tooltip -->
          <template slot="item.agent_notes" slot-scope="props">
            <span v-if="!props.item.agent_notes"></span>
            <v-tooltip bottom v-else>
              <template v-slot:activator="{ on }">
                <span v-on="on">{{
                  props.item.agent_notes.length > 7
                    ? props.item.agent_notes.substring(0, 7) + "..."
                    : props.item.agent_notes
                }}</span>
              </template>
              <div class="font-weight-bold">{{ props.item.agent_notes }}</div>
            </v-tooltip>
          </template>
        </table-component>

        <OrderRequestSection v-if="this.$store.state.openOrderRequestSection" style="margin-top: 50px" />
      </div>
    </div>

    <div style="display: flex; align-items: center; justify-content: center; margin-top: 40px" v-else>
      <LoadingMore />
    </div>

    <v-snackbar v-model="active" color="#40BE72" timeout="-1" right bottom class="ml-4" elevation="24"
      transition="fade-transition">
      <span class="font-weight-bold" style="font-size: 16px">{{ message }}</span>
      <template v-slot:action>
        <v-btn icon small @click="active = false">
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </template>
    </v-snackbar>

    <FundingManagerFilterDialog pageName="all" @fireSearch="searchRequest" />
    <OrderRequestDialog />
    <CallsDialog />
  </div>
</template>

<script>
import LoadingMore from "@/components/Charts/LoadingMore.vue";
import HeaderIcons from "@/views/funding_manager/Requests/HeaderIcons.vue";
import FundingManagerFilterDialog from "@/views/funding_manager/Requests/FundingManagerFilterDialog.vue";
import CallsDialog from "@/components/Charts/CallsDialog.vue";
import { formatDate } from "@/mixins/formatDate";
import OrderRequestDialog from "@/components/AdminComponent/OrderRequestDialog.vue";
import OrderRequestSection from "@/components/AdminComponent/OrderRequestSection.vue";
import AllSingleProcess from "./AllSingleProcess.vue";
import { axiosInstance } from "@/axios/config";


export default {
  name: "WsataUnderReports",
  components: {
    OrderRequestDialog,
    OrderRequestSection,
    FundingManagerFilterDialog,
    LoadingMore,
    HeaderIcons,
    AllSingleProcess,
    CallsDialog,
  },

  data() {
    return {
      allGetData: [],
      customers: [],
      search: '',
      selected_requests: [],
      pagination: {
        limit: 3,
        count: this.$store.state.searchedCount,
      },
      page: 1,
      selectedRows: [],
      allData: [],
      active: false,
      message: "",
      snackbar: {
        show: false,
        message: '',
        color: 'success'
      },
      showSelect: { default: false },
      copySupportRequests: [],
      loadMoreData: false,
      count: null,
      loading: false,
      selectId: null,
      allStatus: [],
      label: "",
      selectedItems: [],
      countPage: 1,
      listenToFreezeAction: this.$store.state.freezeActionIsDone,
      headers: [
        { align: "center", value: "data-table-select", width: "40px" },
        { text: "رقم المعاملة", value: "id", align: "center", width: "90px" },
        { text: "التاريخ", value: "created_at", align: "center", width: "110px" },
        { text: "عميل", value: "customerName", align: "center", width: "130px" },
        { text: "الجوال", value: "CustomerMobile", align: "center", width: "110px" },
        { text: "جهة التمويل", value: "fundingSource", align: "center", width: "130px" },
        { text: "نوع الخدمة", value: "type", align: "center", width: "120px" },
        { text: "مبلغ السداد", value: "mortCost", align: "center", width: "110px" },
        { text: "نوع العقار", value: "realEstateType", align: "center", width: "120px" },
        { text: "قيمة العقار", value: "realEstateCost", align: "center", width: "110px" },
        { text: "قيمة السعي", value: "realEstatePursuit", align: "center", width: "110px" },
        { text: "القيمة المضافة", value: "realEstateValueAdded", align: "center", width: "120px" },
        { text: "رسوم التقييم", value: "realEstateAssmentFees", align: "center", width: "120px" },
        { text: "عمولة المتعاون", value: "collaboratorCommission", align: "center", width: "130px" },
        { text: "الصافي", value: "netValue", align: "center", width: "100px" },
        { text: "اسم المتعاون", value: "collaboratorName", align: "center", width: "140px" },
        { text: "موظف خدمة العملاء", value: "customer_service_name", align: "center", width: "140px" },
        { text: "مسئول المبيعات", value: "userName", align: "center", width: "140px" },
        { text: "الاستشاري السابق", value: "prev_agent", align: "center", width: "140px" },
        { text: "الملاحظات", value: "accountcomment", align: "center", width: "180px" },
        { text: "رهن الوساطه", value: "mortgage_value", align: "center", width: "130px" },
        { text: "رهن تساهيل", value: "tsaheel_mortgage_value", align: "center", width: "130px" },
        { text: "اعتماد محاسب الوساطة", value: "is_approved_by_wsata_acc", align: "center", width: "160px" },
        { text: "اعتماد محاسب تساهيل", value: "is_approved_by_tsaheel_acc", align: "center", width: "160px" },
        { text: "العمليات", value: "action", align: "center", width: "100px" },
      ],
    };
  },

  watch: {
    page(val) {
      if (this.$store.state.isSearch === false && this.search == null) {
        this.getTableData(val);
      } else {
        this.searchRequest(val, "table");
      }
    },

    selected_requests(val) {
      this.selectedItems = val;
      this.$emit("requests", val);
    },

    "$store.state.counterOfShow": {
      handler(newval, oldvalue) {
        if (newval !== oldvalue && !this.$store.state.admin_search_active) {
          this.getTableData(this.page);
        }
      },
    },

    $route: {
      immediate: true,
      handler(newValue, oldValue) {
        if (newValue !== oldValue) {
          this.$store.state.counterOfShow = 10;
        }
      },
    },
  },

  beforeDestroy() {
    this.$store.state.openOrderRequestSection = false;
  },

  methods: {
    showMessage(message, type = 'success') {
      this.snackbar = {
        show: true,
        message,
        color: type
      };
    },

    canEdit(item) {
      const userRole = localStorage.getItem("role");
      return userRole == "8" &&
        item.is_approved_by_wsata_acc === 'لا' &&
        item.statusReq !== 26 &&
        item.statusReq !== 16;
    },

    getLocalFieldName(field) {
      const fieldMap = {
        cust_name: "customerName",
        value_added: "realEstateValueAdded",
        assment_fees: "realEstateAssmentFees",
        collobreator_cost: "collaboratorCommission",
        pursuit: "realEstatePursuit",
      };

      return fieldMap[field] || field;
    },

    hasFieldChanged(item, field, value) {
      const localField = this.getLocalFieldName(field);
      return String(item?.[localField] ?? "") !== String(value ?? "");
    },

    updateLocalField(item, field, value) {
      this.$set(item, this.getLocalFieldName(field), value);
    },

    async updateField(item, field, value) {
      if (!item || !this.hasFieldChanged(item, field, value)) return;

      const previousValue = item[this.getLocalFieldName(field)];
      this.updateLocalField(item, field, value);

      try {
        const response = await axiosInstance.post(
          '/employee/accounting/updateField',
          { id: item.id, field, value },
          { headers: this.request_headers() }
        );

        if (response.data) {
          this.showMessage(response.data.message || 'تم التحديث بنجاح', 'success');
        } else {
          this.updateLocalField(item, field, previousValue);
          this.showMessage('حدث خطأ في التحديث', 'error');
        }
      } catch (error) {
        this.updateLocalField(item, field, previousValue);
        console.error('Update error:', error);
        this.showMessage(error.response?.data?.message || 'حدث خطأ في التحديث', 'error');
      }
    },

    async updateComment(item, value) {
      if (!item || !this.hasFieldChanged(item, "accountcomment", value)) return;

      const previousValue = item.accountcomment;
      this.updateLocalField(item, "accountcomment", value);

      try {
        const response = await axiosInstance.post(
          '/employee/accounting/updatecomm',
          { id: item.id, reqComm: value },
          { headers: this.request_headers() }
        );

        if (response.data) {
          this.showMessage('تم تحديث التعليق بنجاح', 'success');
        } else {
          this.updateLocalField(item, "accountcomment", previousValue);
          this.showMessage('حدث خطأ في التحديث', 'error');
        }
      } catch (error) {
        this.updateLocalField(item, "accountcomment", previousValue);
        console.error('Comment update error:', error);
        this.showMessage(error.response?.data?.message || 'حدث خطأ في التحديث', 'error');
      }
    },


    async updateSingleRow(requestId) {
      try {
        const response = await axiosInstance.get(
          `/v2/employee/Requests/${requestId}`,
          { headers: this.request_headers() }
        );

        if (response.data && response.data.payload) {
          const updatedItem = response.data.payload;

          // Find the index of the row in tableData
          const rowIndex = this.$store.state.tableData.findIndex(
            item => item.id === requestId
          );

          if (rowIndex !== -1) {
            // Create updated row object
            const updatedRow = {
              isSelected: this.$store.state.tableData[rowIndex].isSelected,
              id: updatedItem.id,
              created_at: updatedItem.created_at ? formatDate(updatedItem.created_at) : "",
              type: updatedItem.type || "لا_يوجد",
              customerName: updatedItem.customer?.name || '',
              CustomerMobile: updatedItem.customer?.mobile || '',
              fundingSource: updatedItem.funding?.funding_source_text || '',
              mortCost: updatedItem.prepayments?.mortCost || '',
              realEstateType: updatedItem.real_estate?.type || '',
              realEstateCost: updatedItem.real_estate?.cost || '',
              realEstatePursuit: updatedItem.real_estate?.pursuit || '',
              realEstateValueAdded: updatedItem.real_estate?.value_added || '',
              realEstateAssmentFees: updatedItem.real_estate?.assment_fees || '',
              collaboratorCommission: updatedItem.real_estate?.collobreator_cost || '',
              netValue: updatedItem.real_estate?.calculatedNet || '',
              collaboratorName: updatedItem.collaborator_name || '',
              customer_service_name: updatedItem.customer_service_name? updatedItem.customer_service_name : '-',
              userName: updatedItem.user?.name || '',
              prev_agent: updatedItem.prev_agent || '',
              accountcomment: updatedItem.accountcomment || '',
              mortgage_value: updatedItem.real_estate?.mortgage_value || '',
              tsaheel_mortgage_value: updatedItem.real_estate?.tsaheel_mortgage_value || '',
              is_approved_by_wsata_acc: updatedItem.is_approved_by_wsata_acc == 1 ? "نعم" : "لا",
              is_approved_by_tsaheel_acc: updatedItem.is_approved_by_tsaheel_acc == 1 ? "نعم" : "لا",
              statusReq: updatedItem.statusReq,
              العمليات: updatedItem.sent_basket?.count || '',
            };

            // Replace the row using Vue.set to maintain reactivity
            this.$set(this.$store.state.tableData, rowIndex, updatedRow);
          }
        }
      } catch (error) {
        console.error('Error updating single row:', error);
      }
    },

    getUsersName(users, label, requestId) {
      this.allStatus = users;
      this.label = label;
      this.selectId = requestId;
    },

    handleBack() {
      this.$store.state.allData = [];
      this.$store.state.tableData = [];
      this.allGetData = [];
      this.$store.state.followLoading = true;
      this.$store.state.isSearch = false;
      this.$store.state.back = false;
      this.getLoadTableData(1);
    },

    reloadPage() {
      this.$store.state.allData = [];
      this.$store.state.tableData = [];
      this.allGetData = [];
      this.$store.state.followLoading = true;
      this.$store.state.isSearch = false;
      this.getLoadTableData(1);
      this.$store.state.startElement = [];
    },

    setTblData(res) {
      console.log("res", res);
      this.$store.state.tableData.push({
        isSelected: false,
        id: res.id,
        created_at: res.created_at ? formatDate(res.created_at) : "",
        type: res.type || "لا_يوجد",
        customerName: res.customer?.name || '',
        CustomerMobile: res.customer?.mobile || '',
        fundingSource: res.funding?.funding_source_text || '',
        mortCost: res.prepayments?.mortCost || '',
        realEstateType: res.real_estate?.type || '',
        realEstateCost: res.real_estate?.cost || '',
        realEstatePursuit: res.real_estate?.pursuit || '',
        realEstateValueAdded: res.real_estate?.value_added || '',
        realEstateAssmentFees: res.real_estate?.assment_fees || '',
        collaboratorCommission: res.real_estate?.collobreator_cost || '',
        netValue: res.real_estate?.calculatedNet || '',
        collaboratorName: res.collaborator_name || '',
        userName: res.user?.name || '',
        prev_agent: res.prev_agent || '',
        accountcomment: res.accountcomment || '',
        mortgage_value: res.real_estate?.mortgage_value || '',
        tsaheel_mortgage_value: res.real_estate?.tsaheel_mortgage_value || '',
        is_approved_by_wsata_acc: res.is_approved_by_wsata_acc == 1 ? "نعم" : "لا",
        is_approved_by_tsaheel_acc: res.is_approved_by_tsaheel_acc == 1 ? "نعم" : "لا",
        statusReq: res.statusReq,
        العمليات: res.sent_basket?.count || '',
      });
    },

    getTableData(count) {
      this.$store.state.tableData = [];
      this.loading = true;
      const pageNumber = Number(this.$store.state.counterOfShow);
      axiosInstance
        .get(`/v2/employee/Requests?type=wasatareports_under&page=${count}&per_page=${pageNumber}`, {
          headers: this.request_headers(),
        })
        .then((res) => {
          res.data.payload.data.map((item) => {
            this.setTblData(item);
          });
          this.loading = false;
        })
        .catch((error) => {
          console.error('Get table data error:', error);
          this.loading = false;
        });
    },

    handlePageNumber(val) {
      if (this.$store.state.isSearch === false) {
        this.getLoadTableData(val);
      } else {
        this.searchRequest(val);
      }
    },

    searchRequest(page, type = 'table') {
      this.loading = true;
      this.$store.state.tableData = [];
      this.$store.state.bodySearch.delete("page");
      this.$store.state.bodySearch.append("page", page);

      let url = `/v2/employee/Requests/search?type=wasatareports_under&per_page=${this.$store.state.counterOfShow}`;
      axiosInstance
        .post(url, this.$store.state.bodySearch, { headers: this.request_headers() })
        .then((res) => {
          this.$store.state.pagination = {
            limit: 3,
            count: res.data.payload.searched,
          };
          let response = res.data.payload.data.map((item) => {
            this.setTblData(item);
            item["starChecked"] = false;
            return item;
          });

          this.allGetData.push(...response);
          this.removeDublicate(this.allGetData);
          this.copySupportRequests.push(...response);
        })
        .catch((err) => {
          console.error('Search error:', err);
          this.$store.state.allLoading = false;
          this.loadMoreData = false;
        })
        .finally(() => {
          this.loadMoreData = false;
          this.$store.state.allLoading = false;
          this.loading = false;
        });
    },

    getLoadTableData(page) {
      if (
        this.$store.state.allData.length === 0 ||
        this.copySupportRequests.length === 0
      ) {
        this.$store.state.allLoading = true;
      }
      this.loadMoreData = true;
      axiosInstance
        .get(
          `/v2/employee/Requests?type=wasatareports_under&page=${page}&per_page=${this.$store.state.counterOfShow}`
        )
        .then((res) => {
          this.$store.state.pagination = {
            limit: 3,
            count: res.data.payload.count_of_wasatareports_under,
          };
          let response = res.data.payload.data.map((item) => {
            this.setTblData(item);
            item["starChecked"] = false;
            return item;
          });

          this.allGetData.push(...response);
          this.removeDublicate(this.allGetData);
          this.copySupportRequests.push(...response);
        })
        .catch((err) => {
          console.error('Load table data error:', err);
          this.$store.state.allLoading = false;
          this.loadMoreData = false;
        })
        .finally(() => {
          this.loadMoreData = false;
          this.$store.state.allLoading = false;
        });
    },
  },

  created() {
    this.$store.state.tableData = [];
    this.$store.state.back = false;
    this.$store.state.isSearch = false;
    this.$store.state.bodySearch = new FormData();
    this.getLoadTableData(1);
    this.$store.state.startElement = [];
    this.allLoading = false;
  },
};
</script>

<style>
.button__back {
  width: 70px;
  height: 40px;
  border-radius: 5px;
  margin: 50px;
  color: white;
  background-color: #441545;
  direction: ltr;
}

.noData {
  display: flex;
  justify-content: center;
  font-size: 22px;
  color: #3f0e40;
  margin-top: 70px;
  font-weight: bold;
}

.faild__request {
  border: 1px solid red;
  color: red;
  display: inline-block;
  padding: 0 3px 3px 3px;
  border-radius: 4px;
}

.archive__request {
  border: 1px solid #dbb622;
  color: #dbb622;
  display: inline-block;
  padding: 0 3px 3px 3px;
  border-radius: 4px;
}

.anotherTypes__request {
  border: 1px solid #ff7b1c;
  color: #ff7b1c;
  display: inline-block;
  padding: 0 3px 3px 3px;
  border-radius: 4px;
}

.new__request {
  border: 1px solid green;
  color: green;
  padding: 0 4px 4px 4px;
  border-radius: 4px;
}

.table__view .v-btn:not(.v-btn--round).v-size--small {
  min-width: auto !important;
}

.editable-field {
  width: 100%;
  padding: 2px;
}

.editable-input,
.editable-textarea {
  width: 100%;
  padding: 6px 8px;
  border: 1px solid #e0e0e0;
  border-radius: 4px;
  font-size: 14px;
  color: #222;
  background-color: #f5f5f5;
  transition: all 0.2s;
}

.editable-textarea {
  resize: vertical;
  min-height: 50px;
  font-family: inherit;
}

.editable-input:focus,
.editable-textarea:focus {
  outline: none;
  border-color: #441545;
  color: #222;
  background-color: #fff;
  box-shadow: 0 0 0 2px rgba(68, 21, 69, 0.1);
}

.dark .editable-input,
.dark .editable-textarea {
  color: #f3f5f7;
  background-color: #312b41;
  border-color: #444;
  caret-color: #f3f5f7;
}

.dark .editable-input:focus,
.dark .editable-textarea:focus {
  color: #f3f5f7;
  border-color: #a78bba;
  background-color: #3d354f;
  box-shadow: 0 0 0 2px rgba(167, 139, 186, 0.2);
}


/* Hide arrows from number inputs */
.editable-input[type="number"]::-webkit-inner-spin-button,
.editable-input[type="number"]::-webkit-outer-spin-button {
  -webkit-appearance: none;
  margin: 0;
}

.editable-input[type="number"] {
  appearance: textfield;
  -moz-appearance: textfield;
  /* Firefox */
}
</style>